module.exports = __webpack_public_path__ + "static/img/13.f8a1133.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/13.png
// module id = 4NfD
// module chunks = 0